import { SpinnerOverlay, SpinnerContainer } from "./spinner.styles";

const Spinner = () => (
  <SpinnerOverlay>
    <SpinnerContainer></SpinnerContainer>
  </SpinnerOverlay>
);

export default Spinner;
